import { configurationSettings } from '../../../../configuration/configuration-settings';
import { TicketingMode } from '../../../../configuration/types/order/ticketing-mode';
import { getOrderTicketCountPerAreaCategory } from '../tickets/get-order-ticket-count-per-area-category';
export const getOrderSeatSelectionLimitsPerAreaCategory = (showtimeId, areaCategoryIds) => {
    if (configurationSettings.data.order.ticketingMode === TicketingMode.SeatFirst)
        return undefined;
    const ticketPerAreaCategory = getOrderTicketCountPerAreaCategory(showtimeId);
    const limits = {};
    areaCategoryIds.forEach(areaCategoryId => {
        const ticketCount = ticketPerAreaCategory.get(areaCategoryId);
        if (ticketCount)
            limits[areaCategoryId] = { min: ticketCount, max: ticketCount };
        else
            limits[areaCategoryId] = { min: 0, max: 0 };
    });
    return limits;
};
